import * as Sentry from '@sentry/react';

import { authClient, REFRESH_TOKEN_MIN_VALIDITY } from './auth-client';

export async function updateAuthToken(
  trace?: Record<string, unknown>,
): Promise<string | undefined> {
  if (!authClient.authenticated) {
    return;
  }

  await updateToken(REFRESH_TOKEN_MIN_VALIDITY, trace);
  return authClient.token;
}

export async function refreshAuthToken(): Promise<string | undefined> {
  if (!authClient.authenticated) {
    return;
  }

  await updateToken(Number.POSITIVE_INFINITY);
  return authClient.token;
}

async function updateToken(refreshTokenMinValidityTime: number, trace?: Record<string, unknown>) {
  try {
    // @ts-expect-error custom override accepts trace as second argument
    await authClient.updateToken(refreshTokenMinValidityTime, trace);
  } catch (apiError) {
    Sentry.addBreadcrumb({
      category: 'authentication',
      message: 'Failed to update token',
      data: trace,
    });
    throw apiError;
  }
}
